import { serverUrl } from "../../utils/Settings";

export const printBillUrl = (id: string) => `${serverUrl}/bill/print?id=${id}&printOption=1&printFormat=1`
export const printTicketUrl = (id: string) => `${serverUrl}/api/publicWebShop/tickets?id=${encodeURIComponent(id)}`
